import React from 'react';
import { Button, Form, Input, TextArea, Segment, Grid } from 'semantic-ui-react';
import axios from 'axios';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import { fetchCurrentAcademicYear } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class AddStudentPause extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            documentDate: new Date(),
            documentNumber: null,
            reason: '',
            comment: '',
            semesters: [],
            semester: [],
            reasonOptions: [],
            semesterOptions: [],

            semesterErr: false,

        };
        this.handleChange = this.handleChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getSemestersByAcademicYear = this.getSemestersByAcademicYear.bind(this);
        this.addPause = this.addPause.bind(this);
    }

    getSemestersByAcademicYear(id) {
        axios.get(`semester/by-academic-year/${id}`)
            .then(res => {
                this.setState({
                    semesterOptions: res.data.map(el => ({
                        ...el, key: el.name._key, value: el.id, text: el.name.name + ' ' + el.academicYear.name
                    }))
                });
            });
    }

    componentDidMount() {
        if (this.props.edit) {
            let studentPauseObject = JSON.parse(localStorage.getItem('studentPauseObject'));
            let reason = studentPauseObject.reason.id;
            let {
                date, documentNumber, comment, optLock, id, semesters
            } = studentPauseObject;
            this.setState({
                reason, date: new Date(date), documentNumber, semesters: semesters.map(e => (e.id)), comment, spId: id, optLock
            });
        }

        fetchCurrentAcademicYear().then((res) => {
            const currentAcademicYear = res.data;
            this.setState({ currentAcademicYear }, () => { this.getSemestersByAcademicYear(currentAcademicYear.id); });
        });

        axios.get('/student-pause-reasons')
            .then(res => {
                const reasonOptions = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ reasonOptions });
            })
            .catch(err => {
                console.log('Failed to fetch semesters.');
            });
    }

    addPause(semester) {
        if (semester.length === 0 || !this.state.reason || !this.state.date || !this.state.documentNumber || !this.state.documentDate) {
            toast('Niste unijeli sva obavezna polja!');
            if (semester.length === 0) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
            if (!this.state.reason) { this.setState({ reasonErr: true }); } else { this.setState({ reasonErr: false }); }
            if (!this.state.date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
            if (!this.state.documentDate) { this.setState({ documentDateErr: true }); } else { this.setState({ documentDateErr: false }); }
            if (!this.state.documentNumber) { this.setState({ documentNumberErr: true }); } else { this.setState({ documentNumberErr: false }); }
        } else {
            let obj = {
                studentStudyProgram: { id: this.props.studentStudyProgramId },
                documentNumber: this.state.documentNumber,
                reason: { id: this.state.reason },
                date: moment(this.state.date).format(),
                documentDate: moment(this.state.documentDate).format(),
                comment: this.state.comment,
                semesters: semester.map(e => ({ id: e }))
            };
            axios.post('student-pause/create/', { ...obj })
                .then(ress => {
                    toast('Dodavanje statusa mirovanja je uspješno izvršeno.');
                    this.props.togglePauseVisibility();
                })
                .then(res => {
                    this.props.closeForm();
                    this.props.updateStatus();
                })
                .catch(err => {
                    if (err.response.data === 'This semester is already paused!') {
                        toast('Status mirovanja za odabrani semestar je prethodno dodat.');
                    } else {
                        toast('Došlo je do greške! Dodavanje statusa mirovanja nije uspješno izvršeno.');
                    }
                });
        }
    }

    editPause(semester) {
        if (semester.length === 0 || !this.state.reason || !this.state.date || !this.state.documentNumber || !this.state.documentDate) {
            toast('Niste unijeli sva obavezna polja!');
            if (semester.length === 0) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
            if (!this.state.reason) { this.setState({ reasonErr: true }); } else { this.setState({ reasonErr: false }); }
            if (!this.state.date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
            if (!this.state.documentDate) { this.setState({ documentDateErr: true }); } else { this.setState({ documentDateErr: false }); }
            if (!this.state.documentNumber) { this.setState({ documentNumberErr: true }); } else { this.setState({ documentNumberErr: false }); }
        } else {
            let obj = {
                studentStudyProgram: { id: this.props.studentStudyProgramId },
                optLock: this.state.optLock,
                id: this.state.spId,
                documentNumber: this.state.documentNumber,
                reason: { id: this.state.reason },
                date: moment(this.state.date).format(),
                documentDate: moment(this.state.documentDate).format(),
                comment: this.state.comment,
                semesters: semester.map(e => ({ id: e }))
            };
            axios.put('student-pause/edit/', { ...obj })
                .then(ress => {
                    toast('Izmjena statusa mirovanja je uspješno izvršena.');
                })
                .then(res => {
                    this.props.closeForm();
                    this.props.updateStatus();
                })
                .catch(err => {
                    if (err.response.data === 'This semester is already paused!') {
                        toast('Status mirovanja za odabrani semestar je prethodno dodat.');
                    } else {
                        toast('Došlo je do greške! Izmjena statusa mirovanja nije uspješno izvršena.');
                    }
                });
        }
    }

    handleChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>
                <Segment secondary clearing>
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field required error={this.state.semesterErr} >
                                <label>Semestri</label>
                                <Form.Dropdown
                                    clearable
                                    selection
                                    multiple
                                    placeholder="Odaberite semestre"
                                    value={this.state.semesters}
                                    onChange={this.handleInputChange}
                                    name="semesters"
                                    options={this.state.semesterOptions.filter(el => (el.key !== 'other'))}
                                    search
                                    fluid
                                />
                            </Form.Field>
                            <Form.Field required error={this.state.reasonErr}>
                                <label>Razlog zahtjeva</label>
                                <Form.Dropdown
                                    clearable
                                    selection
                                    placeholder="Odaberite razlog"
                                    value={this.state.reason}
                                    onChange={this.handleInputChange}
                                    name="reason"
                                    options={this.state.reasonOptions}
                                    search
                                    fluid
                                />
                            </Form.Field>
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Field>
                                <label>Datum zahtjeva</label>
                                <DateTimePicker
                                    defaultValue={new Date()}
                                    format="D. M. YYYY."
                                    time={false}
                                    onChange={this.handleChange.bind(null, 'date')}
                                    value={this.state.date}
                                    placeholder="Unesite datum u formatu D. M. GGGG."
                                />
                            </Form.Field>
                            <Form.Field
                                required
                                error={this.state.documentNumberErr}
                                label="Broj odluke"
                                control={Input}
                                name="documentNumber"
                                value={this.state.documentNumber}
                                onChange={this.handleInputChange}
                                placeholder="Unesite broj"
                            />
                            <Form.Field >
                                <label>Datum odluke</label>
                                <DateTimePicker
                                    defaultValue={new Date()}
                                    format="D. M. YYYY."
                                    time={false}
                                    onChange={this.handleChange.bind(null, 'documentDate')}
                                    value={this.state.documentDate}
                                    placeholder="Unesite datum u formatu D. M. GGGG."
                                />
                            </Form.Field>
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Field
                                label="Napomena"
                                control={TextArea}
                                // rows={5}
                                name="comment"
                                value={this.state.comment}
                                onChange={this.handleInputChange}
                                placeholder="Unesite napomenu..."
                            />
                        </Form.Group>

                        <Button
                            basic="true"
                            color="blue"
                            floated="right"
                            onClick={this.props.closeForm}
                        >
                            Odustani
                        </Button>
                        <Button
                            floated="right"
                            color="blue"
                            onClick={this.props.edit ? () => this.editPause(this.state.semesters) : () => this.addPause(this.state.semesters)}
                        >
                            {this.props.edit ? 'Izmijeni' : 'Dodaj'}
                        </Button>
                        <br />
                        <br />
                    </Form>
                </Segment>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/AddStudentPause.js